const routers = [
  {
    // 产品
    path: '/product/list',
    name: 'product',
    component: () => import('@/views/modules/product/List.vue')
  }
]
export default routers
